<template>
  <user-login-wrapper>
    <el-card class="full-card" shadow="always">
      <template #header>
        <div>
          <span class="applicant_title">新規登録</span>
        </div>
      </template>
      <template #default>
        <double-scroll :leftSpan="24">
          <template #left>
            <boundary-info mode="add" />
          </template>
        </double-scroll>
      </template>
    </el-card>
  </user-login-wrapper>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import UserLoginWrapper from '@/components/auth-wrappers/UserLoginWrapper.vue'
import BoundaryInfo from '@/components/layout/BoundaryInfo.vue'
import DoubleScroll from '@/components/layout/DoubleScroll.vue'

/**
 * 境界立会申請件名新規登録
 */
export default defineComponent({
  name: 'BoundaryAdd',
  components: {
    UserLoginWrapper,
    BoundaryInfo,
    DoubleScroll,
  },
})
</script>
